import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const BRF = lazy(() => import("@/pages/elavtal/BRF"));

export const Route = createFileRoute("/elavtal/brf")({
  head: () => seoHead("/elavtal/brf"),
  component: () => <BRF />,
});
